import ScreenCommands from 'screens/Commands';
import { COMMANDS } from 'routes/paths';

const commandsRoutes = [
  {
    path: COMMANDS.LIST,
    name: 'CommandsList',
    component: ScreenCommands,
    loginRequired: true,
    allowPermissions: [],
  },
];

export default commandsRoutes;
